import { Injectable } from '@angular/core';

@Injectable()
export class RecipeDetailCommon {
	
	constructor(
		
	) {

	}

	public commonMethod(){
		console.log("Hello");
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipes/pages/recipe-detail/recipe-detail.common.ts